import {
  FETCH_DISCOVER_NEARBY_REQUEST,
  FETCH_DISCOVER_NEARBY_SUCCESS,
  FETCH_DISCOVER_NEARBY_FAIL,
  CLEAR_DISCOVER_NEARBY,
  SET_DISCOVER_MODE,
} from "./discoverTypes";

const initialState = {
  items: [],
  total: 0,
  page: 1,
  limit: 20,
  mode: "proximity",
  loading: false,
  loadingMore: false,
  error: null,
};

export const discoverReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_DISCOVER_NEARBY_REQUEST:
      return {
        ...state,
        loading: !action.payload?.append,
        loadingMore: !!action.payload?.append,
        error: null,
      };
    case FETCH_DISCOVER_NEARBY_SUCCESS: {
      const { append, items: newItems, total, page, limit, mode } = action.payload;
      return {
        ...state,
        loading: false,
        loadingMore: false,
        total,
        page,
        limit,
        mode: mode ?? state.mode,
        items: append ? [...state.items, ...(newItems ?? [])] : newItems ?? [],
      };
    }
    case FETCH_DISCOVER_NEARBY_FAIL:
      return {
        ...state,
        loading: false,
        loadingMore: false,
        error: action.payload,
      };
    case SET_DISCOVER_MODE:
      return {
        ...state,
        mode: action.payload,
        items: [],
        total: 0,
        page: 1,
      };
    case CLEAR_DISCOVER_NEARBY:
      return initialState;
    default:
      return state;
  }
};
